import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { AGE_RANGES } from "@/constants/forms";
import type { Demographics } from "../hooks/useSubmissionForm";

interface DemographicsStepProps {
  demographics: Demographics;
  onGenderChange: (gender: "any" | "male" | "female") => void;
  onAgeChange: (minAge: number, maxAge: number) => void;
}

export function DemographicsStep({
  demographics,
  onGenderChange,
  onAgeChange,
}: DemographicsStepProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-foreground">Gênero</Label>
        <Select
          value={demographics.gender}
          onValueChange={(value: "any" | "male" | "female") => onGenderChange(value)}
        >
          <SelectTrigger className="border-input bg-background text-foreground">
            <SelectValue placeholder="Selecione o gênero" />
          </SelectTrigger>
          <SelectContent className="border-border bg-card">
            <SelectItem value="any">Qualquer</SelectItem>
            <SelectItem value="male">Masculino</SelectItem>
            <SelectItem value="female">Feminino</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label className="text-foreground">Faixa Etária</Label>
        <Select
          value={`${demographics.minAge}-${demographics.maxAge}`}
          onValueChange={(value) => {
            const range = AGE_RANGES.find((r) => `${r.minAge}-${r.maxAge}` === value);
            if (range) {
              onAgeChange(range.minAge, range.maxAge);
            }
          }}
        >
          <SelectTrigger className="border-input bg-background text-foreground">
            <SelectValue placeholder="Selecione a faixa etária" />
          </SelectTrigger>
          <SelectContent className="border-border bg-card">
            {AGE_RANGES.map((range) => (
              <SelectItem key={range.label} value={`${range.minAge}-${range.maxAge}`}>
                {range.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
